package ir.hosen.resume.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import ir.hosen.resume.components.AutoScrollFAB
import ir.hosen.resume.components.Footer
import ir.hosen.resume.components.NavBar
import ir.hosen.resume.screen.*
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import kotlinx.browser.document
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

object Theme {
    var isDark by mutableStateOf(true)
    var backgroundColor by mutableStateOf(Colors.Black)
    var onBackgroundColor by mutableStateOf(Colors.White)
    var backgroundSurface by mutableStateOf(Color("#0D0D0D"))
}

@Page
@Composable
fun HomePage() {

    val screenDefaultModifier = remember(Theme.isDark) {
        Modifier.padding(top = 64.px).fillMaxWidth().fillMaxHeight().minHeight(100.vh).background(Theme.backgroundColor)
    }

    var colorMode by ColorMode.currentState

    LaunchedEffect(colorMode) {
        val savedTheme = localStorage.getItem(Res.String.SAVED_THEME) ?: ColorMode.LIGHT.name
        colorMode = ColorMode.valueOf(savedTheme)

        Theme.isDark = (colorMode == ColorMode.DARK)

        if (Theme.isDark) {
            Theme.backgroundColor = Colors.Black
            Theme.onBackgroundColor = Colors.White
            Theme.backgroundSurface = Color("#0D0D0D")
        } else {
            Theme.backgroundColor = Colors.White
            Theme.onBackgroundColor = Colors.Black
            Theme.backgroundSurface = Color("#F1F1F1")
        }
    }

    AutoScrollFAB()

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {

        NavBar(onClick = { section ->
            scrollToSection(section)
        }, onToggleTheme = {
            colorMode = colorMode.opposite
            localStorage.setItem(Res.String.SAVED_THEME, colorMode.name)
        })
        ScreenItem.entries.forEach {
            when (it.id) {
                ScreenItem.Home.id -> HomeScreen()
                ScreenItem.ABOUT.id -> AboutScreen(modifier = screenDefaultModifier)
                ScreenItem.EXPERIENCE.id -> {
                    ExperienceRootScreen(modifier = screenDefaultModifier)
                    ExperiencePartTwoScreen(modifier = screenDefaultModifier)
                    ExperiencePartThreeScreen(modifier = screenDefaultModifier)
                }

                ScreenItem.Projects.id -> ProjectsScreen(modifier = screenDefaultModifier)
            }
        }
        Footer()
    }
}

private fun scrollToSection(id: String) {
    val element = document.getElementById(id)
    element?.scrollIntoView(
        js("{ behavior: 'smooth', block: 'start' }")
    )
}